// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { listUserStories, updateStoryTitle, deleteStory } from '../services/api';
import CrisolKrums from '../components/krums/CrisolKrums';
import ReclamoDiario from '../components/krums/ReclamoDiario';
import TiendaPaquetes from '../components/krums/TiendaPaquetes';
import ResumenKrums from '../components/krums/ResumenKrums';
import SaldoWidget from '../components/krums/SaldoWidget';

function Dashboard() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [newTitle, setNewTitle] = useState('');

 /* useEffect(() => {
    loadStories();
  }, []);

  const loadStories = async () => {
    setLoading(true);
    try {
      const response = await listUserStories();
      setStories(response.data.stories || []);
    } catch (error) {
      console.error('Error cargando historias:', error);
    } finally {
      setLoading(false);
    }
  };*/
	
useEffect(() => {
  loadStories();
}, []);

const loadStories = async () => {
  setLoading(true);
  try {
    const response = await listUserStories();
    console.log('📥 Historias recibidas:', response.data);
    setStories(response.data.stories || []);
  } catch (error) {
    console.error('Error cargando historias:', error);
	setStories([]); // ← Importante: si hay error, poner array vacío
  } finally {
    setLoading(false);
  }
};

  const handleEdit = (story) => {
    setEditingId(story.id);
    setNewTitle(story.titulo);
  };

  const handleSave = async (id) => {
    try {
      await updateStoryTitle(id, newTitle);
      setEditingId(null);
      loadStories(); // Recargar lista
    } catch (error) {
      console.error('Error actualizando t&iacute;tulo:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Est&aacute;s seguro de eliminar esta historia?')) {
      try {
        await deleteStory(id);
        loadStories();
      } catch (error) {
        console.error('Error eliminando historia:', error);
      }
    }
  };

  if (loading) {
    return <div className="loading-screen">Cargando tus universos...</div>;
  }

return (
  <div className="dashboard-container">
    <h1>Mis Universos</h1>
    <SaldoWidget />
    
    {Array.isArray(stories) && stories.length === 0 ? (
      <div className="empty-state">
        <p>Aún no has creado ningún universo.</p>
        <Link to="/" className="btn btn-primary">Crear mi primer universo</Link>
      </div>
    ) : Array.isArray(stories) && (
      <div className="stories-grid">
        {stories.map(story => (
          <div key={story.id} className="story-card">
            {editingId === story.id ? (
              <div className="story-edit">
                <input
                  type="text"
                  value={newTitle}
                  onChange={(e) => setNewTitle(e.target.value)}
                  className="edit-input"
                />
                <button onClick={() => handleSave(story.id)} className="btn-save">💾 Guardar</button>
                <button onClick={() => setEditingId(null)} className="btn-cancel">❌ Cancelar</button>
              </div>
            ) : (
              <>
                {/* Imagen de portada */}
                <div className="story-card-image-container">
                  {story.imagen_universo ? (
                    <img 
                      src={story.imagen_universo} 
                      alt={story.titulo} 
                      className="story-thumbnail"
                    />
                  ) : (
                    <div className="story-thumbnail-placeholder">
                      <span>🌌</span>
                    </div>
                  )}
                </div>

                <h3>{story.titulo}</h3>
                <p className="story-meta">
                  Género: {story.genero} | 
                  Creada: {new Date(story.created_at).toLocaleDateString()} <br /> 
                  Última: {new Date(story.ultima_actividad || story.created_at).toLocaleDateString()}
                </p>

                {/* Contador de rondas */}
                <div className="story-stats">
                  <span className="rounds-count">
                    ⚔️ Rondas: {story.total_segmentos || 1}
                  </span>
                  {story.completada && (
                    <span className="completed-badge">✅ Completada</span>
                  )}
                </div>

                <div className="story-actions">
                  <Link to={`/story/${story.id}`} className="btn-continue">
                    ▶️ Continuar
                  </Link>
                  <button onClick={() => handleEdit(story)} className="btn-edit">
                    ✏️ Editar
                  </button>
                  <button onClick={() => handleDelete(story.id)} className="btn-delete">
                    🗑️ Eliminar
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);
}
export default Dashboard;